<template name="selectLanguage">
  <div class="select-language" :class="userType === 1 ? 'col-4' : 'col-12' " v-show="isShow">
    <span @click="showLanguage = !showLanguage">{{ this.locale == 'zh' ? $t('setLangCN') : $t('setLangEN') }}<i></i></span>
    <transition name="slide-fade">
      <div class="language-group" v-show="this.showLanguage">
        <label class="control-label">
          <input checked="checked" id="edit-language-1" name="language" type="radio" value="zh" v-model="locale" @change="onLocaleChange">
          <label for="edit-language-1">{{ $t('setLangCN') }}</label>
        </label>
        <label class="control-label">
          <input id="edit-language-2" name="language" type="radio" value="en" v-model="locale" @change="onLocaleChange">
          <label for="edit-language-2">{{ $t('setLangEN') }}</label>
        </label>
      </div>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
import { setupLang } from '@/locales';
import { setLanguage } from '@/utils/api';
import { getUrlKey } from '@/utils/utils';
import myAuth from '@/utils/auth';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'selectLanguage',
  props: {
    userType: Number,
    url: String,
    isExternal: Boolean,
    isShow: Boolean,
  },
  components: {
    Loading,
  },
  data() {
    return {
      locale: window.localStorage.getItem('localeLanguage'),
      showLanguage: false,
      isLoading: false,
    };
  },
  methods: {
    refreshPage: function(culture) {
      const urlLang = getUrlKey('language');
      const locationHref = location.href;
      if (urlLang) {
        window.location.href = locationHref.replace(urlLang, culture);
      } else {
        window.location.reload();
      }
    },
    onLocaleChange: function(event) {
      this.isLoading = true;
      const _this = this;
      const lang = event.target.value;
      const culture = lang === 'en' ? 'en-US' : 'zh-CN';
      const url = _this.url + culture;

      // Locale side
      setupLang(lang);

      // Backend side
      setLanguage(url).then((res) => {
        this.isLoading = false;
        if (_this.isExternal) {
          myAuth.getRefreshAccessTokenExternal()
          .then((model) => {
            myAuth.setLocalAccessToken(model);
            _this.refreshPage(culture);
          })
          .catch(err => { // in case token is cleared when logout
            this.isLoading = false;
            _this.refreshPage(culture);
          });
        } else {
          myAuth.getRefreshAccessToken().then((model) => {
            myAuth.setLocalAccessToken(model);
            _this.refreshPage(culture);
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .select-language {
    text-align: right;
    span {
      color: #fff;
      cursor: pointer;
      display: inline-block;
      font-size: 14px;
      i {
        display: inline-block;
        position: relative;
        top: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        margin-left: 5px;
        border-width: 5px 4px 0 4px;
        border-color: #fff transparent transparent transparent;
      }
    }
  }
  .language-group {
    position: absolute;
    z-index: 99;
    padding: 15px 20px !important;
    text-align: left;
    background: #fff;
    right: 0;
    width: 96px;
    font-size: 14px;
    color: #929292;
    label {
      line-height: 1;
      margin: 0;
      & + label {
        margin-top: 15px;
      }
    }
    input {
      display: none;
      &:checked + label {
        color: #e42029
      }
    }
  }
</style>

